module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_v_darkbrown.2b14cfac.png";